<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getBanners, deleteBanner as deleteRow } from "@/api/banners";
import { getSurfaces } from "@/api/surfaces";
import { getPartners } from "@/api/partners";

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: {
        sortable: "custom",
        controls: true,
        id: "id",
        edit: true,
        delete_row: {
          buttonName: "Удалить",
        },
        search_list: [
          {
            strong: true,
            name: "surface.id",
            label: "Поверхность",
            type: "select",
            values: [],
          },
          {
            strong: true,
            name: "partner.id",
            label: "Партнер",
            type: "select",
            values: [],
          },
        ],
      },
      columns: [
        {
          prop: "id",
          label: "ID",
        },
        {
          prop: "image",
          label: "Изображение",
          type: "preview",
        },
        {
          prop: "surface",
          label: "Поверхность",
          type: "info",
        },
        {
          prop: "color",
          label: "Цвет",
          type: "info",
        },
        {
          prop: "partner",
          label: "Партнер",
          type: "info",
        },
        {
          prop: "ratio",
          label: "Соотношение сторон",
          type: "info",
        },
        {
          prop: "owner_type",
          label: "Тип владельца",
        },
        {
          prop: "is_active",
          label: "Признак активности",
          type: "bool",
        },
      ],
      methods: {
        async fetchData(params) {
          const data = await getBanners(params);
          return data.banners;
        },
        deleteRow,
      },
    };
  },
  async created() {
    try {
      const surfacesResponse = await getSurfaces();
      const partnersResponse = await getPartners();

      this.columnsOptions.search_list[0].values = surfacesResponse.surfaces.map(
        (surface) => ({
          code: surface.id,
          label: surface.name,
        })
      );

      this.columnsOptions.search_list[1].values = partnersResponse.partners.map(
        (partner) => ({
          code: partner.id,
          label: partner.name,
        })
      );
    } catch (error) {
      console.error("Failed to load filter options:", error);
    }
  },
};
</script>
